import styles from './technicalAspectsLoadingSkeleton.module.scss';

export const TechnicalAspectsLoadingSkeleton = () => (
  <div
    className={styles.technicalAspectsLoadingSkeleton}
    data-testid='technical-aspects-loading-skeleton'
    aria-busy='true'
    aria-label='Loading technical aspects'
  >
    {Array.from({ length: 3 }, (_, sectionIndex) => (
      <section key={sectionIndex} className={styles.section} data-testid='technical-section-skeleton'>
        <div className={styles.heading} aria-hidden='true' />
        <div className={styles.cards}>
          {Array.from({ length: 3 }, (_, cardIndex) => (
            <div key={cardIndex} className={styles.card} data-testid='technical-card-skeleton' aria-hidden='true'>
              <span className={styles.label} />
              <span className={styles.value} />
            </div>
          ))}
        </div>
      </section>
    ))}
  </div>
);
